// src/components/StillsNav/StillsNav.js
import React from "react";
import { NavLink } from "react-router-dom";
import sets from "../../data/stills.json";
import "./StillsNav.css";

function StillsNav() {
  return (
    <div className="StillsNav" role="navigation" aria-label="Stills categories">
      <div className="StillsNav__row">
        <NavLink
          to="/stills"
          end
          className={({ isActive }) =>
            `StillsNav__link ${isActive ? "is-active" : ""}`
          }
        >
          All
        </NavLink>
        {sets.map((s) => (
          <NavLink
            key={s.slug}
            to={`/stills/${s.slug}`}
            className={({ isActive }) =>
              `StillsNav__link ${isActive ? "is-active" : ""}`
            }
          >
            {s.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
export default StillsNav;
